import axios from 'axios'
import lSelector from 'jquery'
import Swal from 'sweetalert2'
import Dashboard from './Dashboard'
import * as Types from '../modules/ModuleType'
import GeneralMethods from '../modules/GeneralMethods'
const Logo = require('../../assets/img/logo.gif')

class IndexPage {
    private _employeeNumber:string
    private _channel:string
    private _GM:GeneralMethods

    constructor() {
        this._employeeNumber = ''
        this._channel = 'sms'
        this._GM = new GeneralMethods()
    }

    public render() {
        return (`
            <main id="content" role="main">
                <div class="position-relative overflow-hidden" style="background-color: #f1f2f3;">
                    <div class="container content-space-2">
                        <div class="row justify-content-center align-items-lg-center">
                            <div class="col-md-8 col-lg-6 mb-7 mb-lg-0">
                                <div class="pe-lg-3 mb-7">
                                    <h1 class="display-3 mb-3 mb-md-5 home_header_text" style="color: #03830A; font-family:Roboto,sans-serif;">Forestry Commission <br>of Ghana</h1>
                                    <p class="lead home_header_sub_text" style="color: #74743c; font-family: 'Nunito', sans-serif;">Staff Terminal Benefit Scheme Portal</p>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <div class="d-flex">
                                            <div class="flex-shrink-0">
                                                <span class="svg-icon text-white">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #03830A;">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1671 18.1421C22.4827 18.4577 23.0222 18.2331 23.0206 17.7868L23.0039 13.1053V5.52632C23.0039 4.13107 21.8729 3 20.4776 3H8.68815C7.2929 3 6.16183 4.13107 6.16183 5.52632V9H13C14.6568 9 16 10.3431 16 12V15.6316H19.6565L22.1671 18.1421Z" fill="#035A4B"/>
                                                        <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M1.98508 18V13C1.98508 11.8954 2.88051 11 3.98508 11H11.9851C13.0896 11 13.9851 11.8954 13.9851 13V18C13.9851 19.1046 13.0896 20 11.9851 20H4.10081L2.85695 21.1905C2.53895 21.4949 2.01123 21.2695 2.01123 20.8293V18.3243C1.99402 18.2187 1.98508 18.1104 1.98508 18ZM5.99999 14.5C5.99999 14.2239 6.22385 14 6.49999 14H11.5C11.7761 14 12 14.2239 12 14.5C12 14.7761 11.7761 15 11.5 15H6.49999C6.22385 15 5.99999 14.7761 5.99999 14.5ZM9.49999 16C9.22385 16 8.99999 16.2239 8.99999 16.5C8.99999 16.7761 9.22385 17 9.49999 17H11.5C11.7761 17 12 16.7761 12 16.5C12 16.2239 11.7761 16 11.5 16H9.49999Z" fill="#035A4B"/>
                                                    </svg>
                                                </span>
                                            </div>

                                            <div class="flex-grow-1 ms-4" style="font-family: 'Nunito', sans-serif;">
                                                <h6 class="mb-0" style="color: #03830A;">24 hours</h6>
                                                <p class="" style="color: #74743c;">Response time</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6">
                                        <div class="d-flex">
                                            <div class="flex-shrink-0">
                                                <span class="svg-icon text-white">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #03830A;">
                                                    <path opacity="0.3" d="M4.875 20.75C4.63542 20.75 4.39583 20.6542 4.20417 20.4625L2.2875 18.5458C1.90417 18.1625 1.90417 17.5875 2.2875 17.2042C2.67083 16.8208 3.29375 16.8208 3.62917 17.2042L4.875 18.45L8.0375 15.2875C8.42083 14.9042 8.99583 14.9042 9.37917 15.2875C9.7625 15.6708 9.7625 16.2458 9.37917 16.6292L5.54583 20.4625C5.35417 20.6542 5.11458 20.75 4.875 20.75Z" fill="#035A4B"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 3C3.34315 3 2 4.34315 2 6V11.865C3.04486 11.3127 4.23591 11 5.5 11C9.47412 11 12.7263 14.091 12.9836 18H18.0249L20.3178 20.2929C20.9478 20.9229 22.0249 20.4767 22.0249 19.5858V15L22 15.0098L22 15V6C22 4.34315 20.6569 3 19 3H5ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44771 9 6 9H15C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7H6Z" fill="#035A4B"/>
                                                    </svg>
                                                </span>
                                            </div>

                                            <div class="flex-grow-1 ms-4" style="font-family: 'Nunito', sans-serif;">
                                                <h6 class="mb-0" style="color: #03830A;">100%</h6>
                                                <p class="" style="color: #74743c;">Access contribution data</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-8 col-lg-6" style="font-family: 'Nunito', sans-serif;">
                                <div class="ps-lg-5">
                                    <div class="card card-lg">
                                        <div class="card-body">
                                            <div class="row text-center mb-5">
                                                <div class="col-md-12 mb-3 text-center">
                                                    <img class="avatar avatar-xxl avatar-4x3" src="${Logo}" alt="Logo">
                                                </div>

                                                <div class="col-md-12 text-center">
                                                    <h5 class="card-title">STB Portal</h5>
                                                    <p class="card-text">Gain full access to your STB contribution history</p>
                                                </div>
                                            </div>

                                            <form class="verifyEmployeeNumberForm" method="POST">
                                                <div class="mb-4">
                                                    <label class="form-label" for="employeeNumber">Enter Your Staff ID</label>
                                                    <input type="text" class="form-control form-control-lg employeeNumber" id="employeeNumber" placeholder="Staff ID" aria-label="Staff ID" data-msg="Enter Your Staff ID." required>
                                                </div>

                                                <div class="d-grid text-center">
                                                    <button type="submit" class="btn btn-primary btn-lg verifyEmployeeNumberFormBtn"> Proceed </button>
                                                    <span class="form-text">
                                                        Need help? 
                                                        <a class="link" href="#">
                                                            Call our service representative now 
                                                            <i class="bi-chevron-right small ms-1"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </form>

                                            <div class="hide chooseChannelForm">
                                                <div class="mb-4">
                                                    <label class="form-label">How would you like to receive your verification code?</label>
                                                </div>

                                                <div class="d-grid gap-3 mb-4">
                                                    <a href="javascript:;" class="btn btn-outline-primary btn-lg d-flex align-items-center justify-content-center channelOptionBtn" data-channel="sms">
                                                        <i class="bi bi-phone me-2"></i> Send code via SMS
                                                    </a>
                                                    <a href="javascript:;" class="btn btn-outline-primary btn-lg d-flex align-items-center justify-content-center channelOptionBtn" data-channel="email">
                                                        <i class="bi bi-envelope me-2"></i> Send code via Email
                                                    </a>
                                                </div>

                                                <div class="text-center">
                                                    <a href="javascript:;" class="link channelBackBtn">
                                                        <i class="bi bi-arrow-left me-1"></i> Back
                                                    </a>
                                                </div>
                                            </div>

                                            <form class="hide verifyOtpForm" method="POST">
                                                <div class="mb-4">
                                                    <label class="form-label otpFormLabel" for="otpNumber">Enter the code sent to your phone number</label>
                                                    <input type="text" class="form-control form-control-lg otpNumber" id="otpNumber" placeholder="OTP Code" aria-label="OTP Code" data-msg="Enter the code sent to your phone number" required>
                                                </div>

                                                <div class="d-grid text-center">
                                                    <button type="submit" class="btn btn-primary btn-lg verifyOtpFormBtn"> Verify </button>
                                                    <span class="form-text">
                                                        Need help? 
                                                        <a class="link" href="#">
                                                            Call our service representative now 
                                                            <i class="bi-chevron-right small ms-1"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        `)
    }

    public methods() {
        lSelector(document).off('submit.formSubmit')
        lSelector(document).off('click.channelSelect')

        this._VerifyEmployeeNumberSubmit()
        this._ChannelSelection()
        this._VerifyOtpNumberSubmit()
    }

    private _VerifyEmployeeNumberSubmit() {
        const thisClass = this
        lSelector(document).on('submit.formSubmit', 'form.verifyEmployeeNumberForm', function(e) {
            e.preventDefault()
            try {
                const employeeNumber:any = lSelector('.employeeNumber', this).val()
                if (!employeeNumber || employeeNumber.trim() === '') {
                    Swal.fire('Caution', 'Please enter your Staff ID', 'warning')
                    lSelector('.swal2-confirm').removeClass('swal2-styled')
                    lSelector('.swal2-confirm').addClass('btn btn-primary')
                    return
                }
                thisClass._employeeNumber = employeeNumber
                lSelector('.verifyEmployeeNumberForm').addClass('hide')
                lSelector('.chooseChannelForm').removeClass('hide')
            } catch (error) {
                console.log('error: ', error)
            }
        })
    }

    private _ChannelSelection() {
        const thisClass = this

        lSelector(document).on('click.channelSelect', 'a.channelOptionBtn', function(e) {
            e.preventDefault()
            const channel = lSelector(this).attr('data-channel') || 'sms'
            thisClass._channel = channel

            lSelector('.channelOptionBtn').addClass('disabled')
            lSelector(this).html(`<div class="spinner-border spinner-border-sm text-primary" role="status"> <span class="visually-hidden">Loading...</span> </div>`)

            axios({
                method: 'POST',
                url: thisClass._GM.apiUrl()+'/login',
                data: {
                    token: '9a741c670d094ba6cf040e12b525bcd7',
                    employee_number: thisClass._employeeNumber,
                    channel: channel
                }
            }).then((res) => {
                const data:Types.loginResponse = res.data

                if (data.status == 'success') {
                    lSelector('.chooseChannelForm').addClass('hide')
                    lSelector('.otpFormLabel').text(channel === 'email' ? 'Enter the code sent to your email' : 'Enter the code sent to your phone number')
                    lSelector('.verifyOtpForm').removeClass('hide')
                } else {
                    Swal.fire(
                        data.status == 'success' ? 'Success' : (data.status == 'caution' ? 'Caution' : 'Error'),
                        data.message,
                        data.status == 'success' ? 'success' : (data.status == 'caution' ? 'warning' : 'error')
                    )
                    lSelector('.swal2-confirm').removeClass('swal2-styled')
                    lSelector('.swal2-confirm').addClass('btn btn-primary')
                }

                thisClass._resetChannelButtons()
            }).catch((error) => {
                console.log('error: ', error)
                thisClass._resetChannelButtons()
            })
        })

        lSelector(document).on('click.channelSelect', 'a.channelBackBtn', function(e) {
            e.preventDefault()
            lSelector('.chooseChannelForm').addClass('hide')
            lSelector('.verifyEmployeeNumberForm').removeClass('hide')
        })
    }

    private _resetChannelButtons() {
        lSelector('.channelOptionBtn').removeClass('disabled')
        lSelector('.channelOptionBtn[data-channel="sms"]').html(`<i class="bi bi-phone me-2"></i> Send code via SMS`)
        lSelector('.channelOptionBtn[data-channel="email"]').html(`<i class="bi bi-envelope me-2"></i> Send code via Email`)
    }

    private _VerifyOtpNumberSubmit() {
        const thisClass = this
        lSelector(document).on('submit.formSubmit', 'form.verifyOtpForm', function(e) {
            e.preventDefault()
            try {
                lSelector('.verifyOtpFormBtn').html(`<div class="spinner-border text-light" role="status"> <span class="visually-hidden">Loading...</span> </div>`)
                lSelector('.verifyOtpFormBtn').attr('disabled', 'disabled')

                const otpNumber = lSelector('.otpNumber', this).val()

                axios({
                    method: 'POST',
                    url: thisClass._GM.apiUrl()+'/otp',
                    data: {
                        token: '9a741c670d094ba6cf040e12b525bcd7',
                        employee_number: thisClass._employeeNumber,
                        otp: otpNumber
                    }
                }).then((res) => {
                    const data:Types.loginResponse = res.data

                    if (data.status == 'caution' || data.status == 'error') {
                        Swal.fire(
                            (data.status == 'caution' ? 'Caution' : 'Error'),
                            data.message,
                            (data.status == 'caution' ? 'warning' : 'error')
                        )
                        lSelector('.swal2-confirm').removeClass('swal2-styled')
                        lSelector('.swal2-confirm').addClass('btn btn-primary')
                    } else {
                        window.localStorage.setItem('mystbstate', JSON.stringify(data))
                        new Dashboard('#myStbMain')
                    }
                    
                    lSelector('.verifyOtpFormBtn').html(`Verify`)
                    lSelector('.verifyOtpFormBtn').removeAttr('disabled')
                }).catch((error) => {
                    console.log('error: ', error)
                    lSelector('.verifyOtpFormBtn').html(`Verify`)
                    lSelector('.verifyOtpFormBtn').removeAttr('disabled')
                }) 
            } catch (error) {
                console.log('error: ', error)
                lSelector('.verifyOtpFormBtn').html(`Verify`)
                lSelector('.verifyOtpFormBtn').removeAttr('disabled')
            }
        })
    }
}

export default IndexPage